import { EMPTY_STR } from "@/constants/string";
import { black, divider, text } from "@/theme/colors";
import { Stack, SxProps, Theme, Typography } from "@mui/material";

type TDetailItemProps = {
  label: string;
  value?: string;
  isInput?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
};

export const DetailItem = ({ label, value, isInput, required, sx }: TDetailItemProps) => (
  <Stack
    gap={1}
    sx={{
      borderBottom: isInput ? `1px solid ${divider.middle}` : "none",
      pb: isInput ? "16px" : 0,
      ...sx,
    }}
  >
    <Typography variant="cap12" color={text.secondary}>
      {label}
      {required && (
        <Typography component="span" variant="cap12" color={text.error}>
          {" *"}
        </Typography>
      )}
    </Typography>
    <Typography
      variant="body14"
      sx={{
        fontWeight: 500,
        wordBreak: "break-word",
      }}
      color={black[30]}
    >
      {value || EMPTY_STR.TEXT}
    </Typography>
  </Stack>
);
